import { useAuth } from '@/context/AuthContext'
import { UserRole } from 'BrokerTsLib/src/dtos'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { useMemo } from 'react'

export const useSettingsMenu = () => {
    const { user } = useAuth() ?? {}

    const showSettings = user?.roles?.some(role => isIn(role, UserRole.Extended, UserRole.Full, UserRole.OuSupervizor))
    const hasExtendedRights = user?.roles?.some(role => isIn(role, UserRole.Extended, UserRole.Full)) && user.isSupervisor
    const settingsItems = useMemo(() => {
        const items = []

        if (showSettings) {
            items.push({
                label: 'Vlastní nastavení',
                to: '/organization',
            })

            if (hasExtendedRights) {
                items.push(
                    { label: 'Organizace', to: '/organization/list' },
                    { label: 'Uživatelé', to: '/user/list' },
                    { label: 'Flexi skupiny', to: '/flex-group/list' },
                    { label: 'Správa aktualit', to: '/news/admin' }
                )
            }

            if (user?.adminCebiaRights) {
                items.push(
                    { label: 'Smazání cache', to: '/ClearCache' },
                )
            }

            if (user?.isSupervisor) {
                items.push(
                    { label: 'Přehled slev', to: '/supervizor/discounts' },
                    { label: 'Helpdesk', to: '/api/HelpDesk/RedirectToHelpDesk' }
                )

                if (user?.rtpcRights) {
                    items.push({ label: 'Správa RTPC', to: '/rtpc' })
                }
            }
        }

        return items
    }, [showSettings, hasExtendedRights, user?.adminCebiaRights, user?.isSupervisor, user?.rtpcRights])

    return {
        showSettings,
        settingsItems
    } as const
}